const isImg = f => f['agent_attachedfile.mime'] && f['agent_attachedfile.mime'].indexOf('image/') == 0;

const getImgFileName = fact => {
  if (!fact) return false;
  if (isImg(fact)) return fact['agent_attachedfile.data'];
  const child = fact.children && fact.children.find(isImg);
  if (!child) return false;
  const imageFileName = child['agent_attachedfile.data'];
  if (!fact['agent_attachedfile.data'] && !fact['agent_attachedfile.mime']) {
    fact['agent_attachedfile.data'] = imageFileName;
    fact['agent_attachedfile.mime'] = child['agent_attachedfile.mime'];
  }
  return imageFileName;
};

export class Fact {

  static isImage(fact) {
    return !!getImgFileName(fact);
  }

  static getImageFileName(fact) {
    return getImgFileName(fact);
  }
}



// WEBPACK FOOTER //
// ./src/common/fact.js